export default __webpack_public_path__ + "static/media/icon3.7ecc5026.svg";